import * as React from "react";

interface State {
  error: Error | null;
  info: React.ErrorInfo | null;
}

interface Props {
  children: React.ReactNode;
}

/**
 * Capture toute exception non gerée dans l'arbre React et affiche une page
 * d'erreur lisible plutôt qu'un panneau blanc. Loggue aussi en console DevTools
 * (F12 sur le task pane).
 */
export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    this.setState({ info });
    // eslint-disable-next-line no-console
    console.error("[GLPI Helper] ErrorBoundary capture :", error, info);
  }

  handleReload = (): void => {
    window.location.reload();
  };

  render(): React.ReactNode {
    if (this.state.error) {
      const message = this.state.error.message || String(this.state.error);
      const stack = this.state.error.stack || "";
      const component = this.state.info?.componentStack || "";

      return (
        <div
          style={{
            padding: 16,
            fontFamily: "Segoe UI, sans-serif",
            color: "#a4262c",
            fontSize: 13,
            lineHeight: 1.4,
            overflowY: "auto",
            height: "100vh",
            boxSizing: "border-box",
          }}
        >
          <h3 style={{ marginTop: 0 }}>Une erreur a interrompu l'add-in</h3>
          <p>
            <strong>{message}</strong>
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: "6px 12px",
              background: "#0078d4",
              color: "white",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            Recharger l'add-in
          </button>

          <details style={{ marginTop: 16, color: "#605e5c" }}>
            <summary>Detail technique</summary>
            <pre style={{ whiteSpace: "pre-wrap", fontSize: 11 }}>{stack}</pre>
            {component && (
              <pre style={{ whiteSpace: "pre-wrap", fontSize: 11 }}>{component}</pre>
            )}
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}
